import { Injectable } from "@angular/core";
import { HttpGeneralService, BillParms, StockParms, CashierParms } from "../../shared/shared";
import { CONFIG } from "../../shared/config";
import { RegPatService } from "../../pricing/reg-pat-service/reg-pat-service";
import {
  ResidenceDegree,
  ResidenceDegreeParms,
} from "../../pricing/residence-degree";
import { ApprovalRequest } from "../../approvals";

let patBillUrl = CONFIG.baseUrls.patBill;
let stockTransUrl = CONFIG.baseUrls.StockTrans;
export interface SummaryPatBill {
  serial: number;
  visitSerial: number;
  visitSerialArr?: string;
  transDate?: Date;
  payed?: number;
  handBillSerial?: number;
  price?: number;
  netPrice?: number;
  patPrice?: number;
  sharedPrice?: number;
  remainingOnPat?: number;
  remainingToPat?: number;
  percentOrValue?: number;
  discountType?: number;
  discountValue?: number;
  cshDiscountsCode?: number;
  stamp?: number;
  tax?: number;
  medicalService?: number;
  status: number;
  cancelReasonCode?: number;
  cancelReasonNotes?: string;
  medicalCaseType?: number;
  memoDoc?: number;
  memoCode?: number;
  totalMemosValue?: number;
  loanEmpCode?: number;
  sharedVat?: number;
  patVat?: number;
  vatValue?: number;
  contractId?: number;
  parentBillSummaryPatBill?: number;
  contractNameAr?: string;
  patPricePrecent?: number;
  sharedPricePrecent?: number;
  govVat?: number;
  notes?: string;
  billTransferToLoan?: boolean,
  visitPayments?: number;
  advancePayments?: number;
}

export interface DetailsPatBill {
  serial: number;
  billItemCode: number;
  billSummaryPatBillSerial?: number;
  price: number;
  netPrice: number;
  patPrice: number;
  sharedPrice: number;
  remainingPrice?: number;
  percentOrValue?: number;
  discountValue?: number;
  medicalLitterValue?: number;
  disVal?: number;
  actualPrice?: number;
  actualNetPrice?: number;
  actualPatPrice?: number;
  actualSharedPrice?: number;
  sharedVat?: number;
  patVat?: number;
  vatValue?: number;
  prepaidservice?: number; //nada
  prepaidserviceTotalUsedAmount?: number; //nada
}

export interface PatBill {
  summaryPatBill: SummaryPatBill;
  detailsPatBill: DetailsPatBill[];
}

export interface PatServicesObj {
  jsonObject: string;
  approvalRequestJson: string;
  dataStatus: number;
}

export interface PatService extends PatServicesObj { }

export interface PatServices {
  patServicesArray: PatService[];
  approvalRequestArray: ApprovalRequest[];
}

export interface PropToSetInDeal {
  type?: number;
  dealSerial?: number;
  servSerial?: number;
  addOrDelete?: number;
}

export interface ResidenceDay {
  visitSerial: number;
  type: number;
  transDate: Date;
  ngbTransDate?: any;
  resDegreeSerial: number;
  companionCode?: number;
}

@Injectable()
export class PatBillService {
  constructor(private httpGeneralService: HttpGeneralService) { }

  getPatBill(visitSerial: String) {
    return this.httpGeneralService.getWith(
      `${patBillUrl}/BillItems/${visitSerial}`
    );
  }

  getPatVisitServices(visitSerial: number, type: number) {
    return this.httpGeneralService.getWith(
      `${patBillUrl}/PatVisitServices/${visitSerial}/${type}`
    );
  }

  updatePatVisitServices(patServices: PatServices, type: number) {
    return this.httpGeneralService.add(
      patServices,
      `${patBillUrl}/PatVisitServices/${type}`
    );
  }
  MoveServiceToOtherVisits(patServices: PatServices, type: number) {
    return this.httpGeneralService.add(
      patServices,
      `${patBillUrl}/MoveServiceToOtherVisits/${type}`
    );
  }
  addPatBill(patBill: PatBill) {
    return this.httpGeneralService.add<PatBill>(patBill, patBillUrl);
  }
  updatPatBill(patBill: PatBill) {
    return this.httpGeneralService.add<PatBill>(
      patBill,
      `${patBillUrl}/UpdatPatBill`
    );
  }
  Discountafterextractedpatbills(patBill: PatBill) {
    return this.httpGeneralService.add<PatBill>(
      patBill,
      `${patBillUrl}/Discountafterextractedpatbills`
    );
  }
  getBillInfo(patBillSerial: number, factor: number) {
    return this.httpGeneralService.getWith(
      `${patBillUrl}/BillInfo/${patBillSerial}/${factor}`
    );
  }

  GetPatBills(billParms: BillParms) {
    return this.httpGeneralService.add<BillParms>(
      billParms,
      `${patBillUrl}/PatBills`
    );
  }

  getPatientAccountSummary(billParms: CashierParms) {
    return this.httpGeneralService.add<CashierParms>(
      billParms,
      `${patBillUrl}/getPatientAccountSummary`
    );
  }

  DailyPackagesDeals(billParms: BillParms) {
    return this.httpGeneralService.add<BillParms>(
      billParms,
      `${patBillUrl}/DailyPackagesDeals`
    );
  }

  DailyBillItemInsuranceModify(billParms: BillParms) {
    return this.httpGeneralService.add<BillParms>(
      billParms,
      `${patBillUrl}/DailyBillItemInsuranceModify`
    );
  }
  DailyPackagesDealsSave(dailyPackageDealsArr: any[]) {
    return this.httpGeneralService.addCollection(
      dailyPackageDealsArr,
      `${patBillUrl}/DailyPackagesDealsSave`
    );
  }
  DailyBillItemSave(dailyPackageDealsArr: any[]) {
    return this.httpGeneralService.addCollection(
      dailyPackageDealsArr,
      `${patBillUrl}/DailyBillItemSave`
    );
  }
  DailyBillItemUpdate(dailyPackageDealsArr: any[]) {
    return this.httpGeneralService.addCollection(
      dailyPackageDealsArr,
      `${patBillUrl}/DailyBillItemUpdate`
    );
  }

  DailyBillItemDelete(serial: number) {
    return this.httpGeneralService.delete(
      serial,
      `${patBillUrl}/DailyBillItemDelete`
    );
  }
  GetVisitModifingLog(billParms: BillParms) {
    return this.httpGeneralService.add<BillParms>(
      billParms,
      `${patBillUrl}/VisitModifingLog`
    );
  }

  MoveServiceToNewVisit(regPatServices: RegPatService[]) {
    return this.httpGeneralService.addCollection(
      regPatServices,
      `${patBillUrl}/MoveService`
    );
  }

  AddOrDeleteSIRFromDeal(propToSetInDeal: PropToSetInDeal[]) {
    return this.httpGeneralService.addCollection<PropToSetInDeal>(
      propToSetInDeal,
      `${patBillUrl}/ServicesRelationwithDeal`
    );
  }

  AddResidenceDay(residenceDay: ResidenceDay) {
    return this.httpGeneralService.add<ResidenceDay>(
      residenceDay,
      `${patBillUrl}/residenceDay`
    );
  }

  updateStartDateforServices(objData: any) {
    return this.httpGeneralService.post(
      objData,
      `${patBillUrl}/UpdateStartDateforServices`
    );
  }
  updateServiceToCash(objData: any) {
    return this.httpGeneralService.post(
      objData,
      `${patBillUrl}/updateServiceToCash`
    );
  }
  getResidenceDegreeCost(residenceDegree: ResidenceDegreeParms[]) {
    return this.httpGeneralService.add(
      residenceDegree,
      `${patBillUrl}/residenceDegreeCost`
    );
  }

  RegPatServiceDiscount(patServiceSerial: number) {
    return this.httpGeneralService.getWith(
      `${patBillUrl}/RegPatServiceDiscount/${patServiceSerial}`
    );
  }

  updateRegPatServiceDiscount(_RegPatService: RegPatService) {
    return this.httpGeneralService.update<RegPatService>(
      _RegPatService.serial,
      _RegPatService,
      patBillUrl
    );
  }
  GetRepDetailBillinfo(patBillSerial: number) {
    return this.httpGeneralService.getWith(
      `${patBillUrl}/GetRepDetailBill/${patBillSerial}`
    );
  }
  GetRepDetailBillinfoAlmaza(patBillSerial: number) {
    return this.httpGeneralService.getWith(
      `${patBillUrl}/GetRepDetailBillinfoAlmaza/${patBillSerial}`
    );
  }
  GetRepDetailBillinfoSigal(patBillSerial: number) {
    return this.httpGeneralService.getWith(
      `${patBillUrl}/GetRepDetailBillinfoSigal/${patBillSerial}`
    );
  }
  addbillSummaryPatBill(billParmArray: SummaryPatBill[]) {
    return this.httpGeneralService.addCollection(
      billParmArray,
      `${patBillUrl}/addbillSummaryPatBill`
    );
  }
  updateBillPatServiceFakePrice(objData: any) {
    return this.httpGeneralService.post(
      objData,
      `${patBillUrl}/updateBillPatServiceFakePrice`
    );
  }
  itemsLoad(_StockParms: StockParms[]) {
    return this.httpGeneralService.addCollection<StockParms>(
      _StockParms,
      `${stockTransUrl}/itemsLoad`
    );
  }
  dividVisit(objData: any) {
    return this.httpGeneralService.post(objData, `${patBillUrl}/dividVisit`);
  }
  deleteResidenceIfDeviceExsit(objData: any) {
    return this.httpGeneralService.post(
      objData,
      `${patBillUrl}/AlmazaDeleteResidenceIfDeviceExsit`
    );
  }
  updateDiscountService(objData: any) {
    return this.httpGeneralService.post(
      objData,
      `${patBillUrl}/updateDiscountService`
    );
  }

  getDisContServiceRequest(DiscountRequests: any) {
    return this.httpGeneralService.post(DiscountRequests, `${patBillUrl}/getDisContServiceRequest`);
  }
  updateStatusDisCountRequest(objData: any) {
    return this.httpGeneralService.post(
      objData,
      `${patBillUrl}/updateStatusDisCountRequest`
    );
  }

}

export interface PatientEdits {
  regPatServiceSerial?: number;
  startDate?: Date;
  stockTransMasterSerial?: number;
  transCode?: string;
  transDate?: Date;
}
